/**
 * Ride-hail company logos from public/images/ride-hail (WebP from iOS Assets).
 * Mapping mirrors iOS RideHailSection.logoImageName(for:).
 */

const LOGOS_BASE = '/images/ride-hail';

/** Company display name → asset stem (without .webp). */
const COMPANY_TO_ASSET: Record<string, string> = {
  Uber: 'Uber_logo',
  Bolt: 'Bolt_logo',
  Lyft: 'Lyft_logo',
  Careem: 'Careem_logo',
  DiDi: 'Didi_logo',
  'DiDi Chuxing': 'Didi_logo',
  'Free Now': 'Freenow_logo',
  FREENOW: 'Freenow_logo',
  Cabify: 'Cabify_logo',
  Ola: 'Ola_logo',
  'Ola Cabs': 'Ola_logo',
  Grab: 'Grab_logo',
  Gojek: 'Gojek_logo',
  'Yandex Go': 'Yandex_Go_logo',
  Yango: 'Yango_logo',
  Gett: 'Gett_logo',
  Beat: 'Beat_app_logo',
  Via: 'Via_logo',
  Liftago: 'Liftago_logo',
  Pathao: 'Pathao_logo',
  Rapido: 'Rapido-logo',
  Yassir: 'Yassir_logo',
  'Sixt Ride': 'Sixt_logo',
  Sixt: 'Sixt_logo',
  Shohoz: 'Shohoz_logo',
  Shohoj: 'Shohoz_logo',
};

function assetUrl(stem: string): string {
  return `${LOGOS_BASE}/${encodeURIComponent(stem)}.webp`;
}

/** Resolve a ride-hail company name to a public WebP URL, or null if unknown. */
export function rideHailLogoUrl(companyName: string): string | null {
  const normalized = companyName.trim();
  if (!normalized) return null;

  const exact = COMPANY_TO_ASSET[normalized];
  if (exact) return assetUrl(exact);

  const lower = normalized.toLowerCase();
  for (const [key, stem] of Object.entries(COMPANY_TO_ASSET)) {
    if (key.toLowerCase() === lower) return assetUrl(stem);
  }

  for (const [key, stem] of Object.entries(COMPANY_TO_ASSET)) {
    const keyLower = key.toLowerCase();
    if (lower.includes(keyLower) || keyLower.includes(lower)) return assetUrl(stem);
  }

  return null;
}
